import {
    PlayerContainer,
    ConnectedOverlay,
    ConnectedControlBarWithControls,
    ConnectedPlayPause,
    ConnectedLoader,
} from '@dicetechnology/doris-ui';
import React from 'react';

export const PlayerInterface = ({ player }) => (
    <div className="ds-container">
        <PlayerContainer player={player}>
            <ConnectedOverlay>
                <ConnectedPlayPause className="ds-play-pause--big-centered" />
                <ConnectedLoader />
                <ConnectedControlBarWithControls />
            </ConnectedOverlay>
        </PlayerContainer>
    </div>
);
